import React from "react";
import Typography from "../../ui/widgets/typography";
import CustomList from "../../ui/widgets/list";
import CustomListItem from "../../ui/widgets/list/list-item";
import TypographyContainer from "../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../ui/layout/page/typography-container/typography-item-container";
import CustomLink from "../../ui/widgets/link";
import CheckboxContainer from "../../ui/layout/page/forms-container/form-item-container/checkbox-container";
import CheckboxField from "../shared/components/formik/checkbox";
import SectionFullWidthContainer from "../../ui/layout/page/forms-container/section-full-width-container";
import { useMessageSource } from "react-message-source";
import { NaturalPersonDocument } from "../../api/commercial/generated-types";

interface AuthorizedRepresentativesProps {
  authorizedRepresentatives: NaturalPersonDocument[];
}

const AuthorizedRepresentatives: React.FC<AuthorizedRepresentativesProps> = ({
  authorizedRepresentatives,
}: AuthorizedRepresentativesProps) => {
  const { getMessage } = useMessageSource();

  const handleOnExternalLink = (): void => {
    window.open(getMessage("CompanyOnline-authorization.link"), "_blank");
  };

  return (
    <SectionFullWidthContainer>
      <div className="scd-section-pusher-sm">
        <Typography className="scd-container-base-small">
          {getMessage("CompanyOnline-authorization.info")}
        </Typography>
        <CustomList isBulletsList>
          <CustomListItem>
            {getMessage("CompanyOnline-authorization.info-bullet")}
          </CustomListItem>
        </CustomList>

        <TypographyContainer>
          <TypographyItemContainer>
            <Typography variant="body2" className="scd-container-base-small">
              <CustomLink onClick={handleOnExternalLink}>
                {getMessage("CompanyOnline-authorization.link-text")}
              </CustomLink>
            </Typography>
          </TypographyItemContainer>
        </TypographyContainer>

        {authorizedRepresentatives.map((authorizedRepresentative, index) => (
          <CheckboxContainer
            key={`${authorizedRepresentative.address}-${index}`}
          >
            <CheckboxField
              key={`${authorizedRepresentative.address}-${index}`}
              name={`authorizedRepresentatives.${index}.isCompanyOnlineAdmin`}
              label={`${authorizedRepresentative.firstName} ${authorizedRepresentative.lastName}`}
            />
          </CheckboxContainer>
        ))}
      </div>
    </SectionFullWidthContainer>
  );
};

export default AuthorizedRepresentatives;
